import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import settings from "../../apiConfigs/settings";
import { ReactComponent as Delete } from "../../assets/delete.svg";
import { ReactComponent as Edit } from "../../assets/edit.svg";
import DeleteModal from "../../designComponents/DeleteModal";
import LabelInputField from "../../designComponents/LabelInputField/LabelInputField";
import MediaUploader from "../../designComponents/MediaUpload/MediaUpload";
import Modal from "../../designComponents/Modal";
import requestAPI from "../../utils/requestAPI";
import { uploadFilesToS3OnlyKeys } from "../../utils/s3Upload";
import {
  AcceptButton,
  ButtonsSection,
  Card,
  LabelText,
  SectionTitle,
  TitleSection
} from "../Properties/Details/styles";
import { getIconsUrl } from "../../utils/resizeImages";

function RulesCategories() {
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);

  const [rulesCategory, setRulesCategory] = useState<
    { title: string; _id: string; icon: string }[]
  >([]);
  const [openDeleteModal, setOpenDeleteModal] = useState<string | null>(null);
  const [title, setTitle] = useState<string>("");
  const [initialValues, setInitialValues] = useState<{
    title: string;
    icon: string | null | File;
  }>({ title: "", icon: "" });
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [openEditModal, setOpenEditModal] = useState<string | null>(null);

  const getRulesCategories = async () => {
    const response = await requestAPI(settings.getRulesCategory());
    setRulesCategory(response.data);
  };
  useEffect(() => {
    getRulesCategories();
  }, []);
  // if (rulesCategory.length === 0) {
  //   return (
  //     <div>
  //       <TitleSection></TitleSection>
  //       <Card style={{ margin: 0 }}>
  //         <ButtonsSection>
  //           <SectionTitle>Rules Category</SectionTitle>
  //           <AcceptButton
  //             onClick={() => {
  //               setOpenModal(true);
  //             }}
  //           >
  //             Add Category
  //           </AcceptButton>
  //         </ButtonsSection>
  //         <ValueText> No Rule Categories yet </ValueText>
  //       </Card>
  //     </div>
  //   );
  // }
  const handleDeleteRules = async (id: string) => {
    try {
      await requestAPI(settings.deleteRulesCategory(id));
      toast.success("Successfully Deleted");
      setOpenDeleteModal(null);
      getRulesCategories();
    } catch (error: any) {
      toast.error("Error " + error.message);
    }
  };
  const handleAdd = async () => {
    let providedUrl;
    try {
      console.log(uploadedFile, "file");
      if (uploadedFile && typeof uploadedFile !== "string") {
        const uploadFiles = await uploadFilesToS3OnlyKeys({category:'assets',fileUri:[uploadedFile],assetsCategory:'Rule Categories'});
        if (uploadFiles && uploadFiles.length > 0) {
          providedUrl = uploadFiles[0];
          await requestAPI(
            settings.addRulesCategory({ title: title, icon: providedUrl })
          );
        }
      } else if (typeof uploadedFile === "string") {
        providedUrl = uploadedFile;
        await requestAPI(
          settings.addRulesCategory({ title: title, icon: providedUrl })
        );
      }
      setOpenModal(false);
      setTitle("");
      setUploadedFile(null);
      toast.success("Successfylly Added Rule Category");
      getRulesCategories();
    } catch (error: any) {
      toast.error("Error:" + error.message);
    }
  };
  const handleEdit = async (id: string) => {
    let providedUrl;
    try {
      console.log(uploadedFile, "file");
      if (uploadedFile && typeof uploadedFile !== "string") {
        const uploadFiles = await uploadFilesToS3OnlyKeys({category:'assets',fileUri:[uploadedFile],assetsCategory:'Rule Categories'});
        if (uploadFiles && uploadFiles.length > 0) {
          providedUrl = uploadFiles[0];
          await requestAPI(
            settings.updatRulesCategory({
              data: { title: initialValues.title, icon: providedUrl },
              id: id,
            })
          );
        }
      } else if (typeof uploadedFile === "string") {
        providedUrl = uploadedFile;
        await requestAPI(
          settings.updatRulesCategory({
            data: { title: initialValues.title, icon: providedUrl },
            id: id,
          })
        );
      } else if (!uploadedFile) {
        await requestAPI(
          settings.updatRulesCategory({
            data: {
              title: initialValues.title,
              icon: initialValues.icon as string,
            },
            id: id,
          })
        );
      }
      setOpenEditModal(null);
      setInitialValues({ title: "", icon: "" });
      getRulesCategories();
      toast.success("Successfylly Updated Rule Category");
    } catch (error: any) {
      toast.error("Error:" + error.message);
    }
  };
  return (
    <div>
      <Card style={{ margin: 0 }}>
        <TitleSection>
          <ButtonsSection>
            <SectionTitle>Rules Category</SectionTitle>
            <AcceptButton
              onClick={() => {
                setOpenModal(true);
              }}
            >
              Add Category
            </AcceptButton>
          </ButtonsSection>
        </TitleSection>
        {rulesCategory.map((item, index) => {
          return (
            <ButtonsSection key={index}>
              <div
                style={{
                  display: "flex",
                  gap: 40,
                  alignItems: "center",
                }}
              >
                <img
                  src={getIconsUrl(item.icon)}
                  width={40}
                  height={40}
                  style={{ borderRadius: 40 }}
                  alt={item.title}
                ></img>
                <LabelText>{item.title}</LabelText>
              </div>
              <div style={{ display: "flex", gap: 20, cursor: "pointer" }}>
                <div
                  onClick={() => {
                    setOpenDeleteModal(item._id);
                  }}
                >
                  <Delete fill="#7E7E7E"></Delete>
                </div>
                <div
                  onClick={() => {
                    setOpenEditModal(item._id);
                    setInitialValues({
                      title: item.title,
                      icon: item.icon,
                    });
                  }}
                >
                  <Edit fill="#7E7E7E" />
                </div>
              </div>

              {openDeleteModal === item._id && (
                <DeleteModal
                  loading={false}
                  onClose={() => {
                    setOpenDeleteModal(null);
                  }}
                  itemName="Category"
                  title="Are you sure you want to delete this Category"
                  isOpen={true}
                  onDelete={() => {
                    handleDeleteRules(item._id);
                  }}
                ></DeleteModal>
              )}

              {openEditModal === item._id && (
                <Modal
                  halfWidth
                  isOpen={true}
                  title="Edit Rule Category"
                  onClose={() => {
                    setOpenEditModal(null);
                  }}
                >
                  <LabelInputField
                    label="Title Name"
                    value={initialValues.title}
                    onChange={(e) => {
                      setTitle(e.target.value);
                      setInitialValues({
                        title: e.target.value,
                        icon: initialValues.icon,
                      });
                    }}
                    name="title"
                    style={{
                      label: {
                        fontSize: "14px",
                        fontWeight: "500px",
                        color: "#555A77",
                      },
                      input: {
                        height: 50,
                        border: "1px solid #F1EFFB",
                        padding: 8,
                        background: "#F1EFFB",
                        borderRadius: 6,
                        width: "100%",
                      },
                      container: {
                        display: "flex",
                        flexDirection: "column",
                        gap: 6,
                        paddingTop: 14,
                      },
                    }}
                  ></LabelInputField>
                  <MediaUploader
                    label="Icon"
                    image={
                      initialValues.icon &&
                      typeof initialValues.icon === "string"
                        ? [initialValues.icon]
                        : []
                    }
                    onChange={(e) => {
                      const file = e.target.files?.[0] || null;
                      setInitialValues({
                        title: initialValues.title,
                        icon: file,
                      });
                    }}
                    style={{
                      container: { paddingTop: 10, gap: 6, marginBottom: 10 },
                      label: { paddingBottom: 10, color: "#555A77" },
                      dropzone: { background: "#F1EFFB" },
                    }}
                  ></MediaUploader>
                  <AcceptButton
                    onClick={() => {
                      handleEdit(item._id);
                    }}
                  >
                    Confirm
                  </AcceptButton>
                </Modal>
              )}
            </ButtonsSection>
          );
        })}
        <Modal
          halfWidth
          isOpen={openModal}
          title="Add Rule Category"
          onClose={() => {
            setOpenModal(false);
          }}
        >
          <LabelInputField
            label="Title Name"
            onChange={(e) => {
              setTitle(e.target.value);
            }}
            name="title"
            style={{
              label: {
                fontSize: "14px",
                fontWeight: "500px",
                color: "#555A77",
              },
              input: {
                height: 50,
                border: "1px solid #F1EFFB",
                padding: 8,
                background: "#F1EFFB",
                borderRadius: 6,
                width: "100%",
              },
              container: {
                display: "flex",
                flexDirection: "column",
                gap: 6,
                paddingTop: 14,
              },
            }}
          ></LabelInputField>
          <MediaUploader
            label="Icon"
            onChange={(e) => {
              const file = e.target.files?.[0] || null;
              setUploadedFile(file);
            }}
            style={{
              container: { paddingTop: 10, gap: 6, marginBottom: 10 },
              label: { paddingBottom: 10, color: "#555A77" },
              dropzone: { background: "#F1EFFB" },
            }}
          ></MediaUploader>
          <AcceptButton
            onClick={() => {
              handleAdd();
            }}
          >
            {" "}
            Add
          </AcceptButton>
        </Modal>
      </Card>
    </div>
  );
}

export default RulesCategories;
